'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true,
});
exports.default = void 0;
var _react = _interopRequireDefault(require('react'));
var _internal = require('@atlaskit/icon-file-type/internal');
function _interopRequireDefault(e) {
	return e && e.__esModule ? e : { default: e };
}
const Video24Icon = (props) =>
	/*#__PURE__*/ _react.default.createElement(
		_internal.Icon,
		Object.assign(
			{
				dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`,
			},
			props,
			{
				size: 'medium',
			},
		),
	);
Video24Icon.displayName = 'Video24Icon';
var _default = (exports.default = Video24Icon);
